import axios from 'axios'
import isEmpty from 'lodash/isEmpty'
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../shared/vars'

// ====================
// CLEAR MESSAGES
// ====================
export const clearMessages = () => {
	return {
		type: 'CLEAR_TOPTIER_MESSAGES'
	}
}

// ====================
// GET ALL TOP TIERS
// ====================
export const loadTopTierLoading = () => {
	return {
		type: 'LOAD_TOPTIER_LOADING'
	}
}

export const loadTopTierError = (err)  => {
	return {
		type: 'LOAD_TOPTIER_ERROR',
		errors: err
	}
}

export const loadTopTierSuccess = (data)  => {
	return {
		type: 'LOAD_TOPTIER_SUCCESS',
		data
	}
}

export function loadTopTiers(){
	return (dispatch, getState) => {
		dispatch(clearMessages())
		dispatch(loadTopTierLoading())
		
		const token = getState().user.admin.token;
		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token }

		return axios.get(REACT_APP_API_URL + 'top-tier/', { headers: AUTH_HEADER })
		.then((response) => {
			// Error explicitly set
			if (!isEmpty(response.data.errors)) {
				dispatch(loadTopTierError(response.data.errors))

			// Error status
			} else if (!!response.data.status && response.data.status !== 200) {
				dispatch(loadTopTierError({ 'general': response.data.message }))

			// Success
			} else {
				dispatch(loadTopTierSuccess(response.data))
			}
		})
		.catch((err) => {
			console.log('loadTopTier error:', err.response)
			dispatch(loadTopTierError(err.response.data.message))
		})
	}
}

// =============================
// GET ALL CUSTOMERS + TOP TIERS
// =============================
export const loadCustomersLoading = () => {
	return {
		type: 'LOAD_CUSTOMERS_LOADING'
	}
}

export const loadCustomersError = (err)  => {
	return {
		type: 'LOAD_CUSTOMERS_ERROR',
		errors: err
	}
}

export const loadCustomersSuccess = (data)  => {
	return {
		type: 'LOAD_CUSTOMERS_SUCCESS',
		data
	}
}

export function loadCustomers(){
	return (dispatch, getState) => {
		dispatch(clearMessages())
		dispatch(loadCustomersLoading())
		
		const token = getState().user.admin.token;
		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token }

		return axios.get(REACT_APP_API_URL + 'top-tier-customers/?all=true', { headers: AUTH_HEADER })
		.then((response) => {
			// Error explicitly set
			if (!isEmpty(response.data.errors)) {
				dispatch(loadCustomersError(response.data.errors))

			// Error status
			} else if (!!response.data.status && response.data.status !== 200) {
				dispatch(loadCustomersError({ 'general': response.data.message }))

			// Success
			} else {
				dispatch(loadCustomersSuccess(response.data))
			}
		})
		.catch((err) => {
			console.log('loadTopTier error:', err.response)
			dispatch(loadCustomersError(err.response.data.message))
		})
	}
}

// =======================
// UPDATE TOP TIER PRODUCT
// =======================
export const updateTopTierProductLoading = () => {
	return {
		type: 'UPDATE_TTP_LOADING'
	}
}

export const updateTopTierProductError = (err)  => {
	return {
		type: 'UPDATE_TTP_ERROR',
		errors: err
	}
}

export const updateTopTierProductSuccess = (data)  => {
	return {
		type: 'UPDATE_TTP_SUCCESS',
		data
	}
}

export function updateTopTierProduct(data){
	return (dispatch) => {
		dispatch(updateTopTierProductLoading())

		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY }
		const params = {
            ...data
		}

		return axios.post(REACT_APP_API_URL + 'top-tier-products/', params, { headers: AUTH_HEADER })
		.then((response) => {
			// Error explicitly set
			if (!isEmpty(response.data.errors)) {
				dispatch(updateTopTierProductError(response.data.errors))

			// Error status
			} else if (!!response.data.status && response.data.status !== 200) {
				dispatch(updateTopTierProductError({ 'general': response.data.message }))

			// Success
			} else {
				dispatch(updateTopTierProductSuccess(response.data))
			}
		})
		.catch((err) => {
			// console.log('updateTopTierProduct error:', err.response)
			// dispatch(updateTopTierProductError(err.response.data.message))
		})
	}
}

// =========================
// UPDATE TOP TIER CUSTOMERS
// =========================
export const updateTopTierCustomersLoading = () => {
	return {
		type: 'UPDATE_TTC_LOADING'
	}
}

export const updateTopTierCustomersError = (err)  => {
	return {
		type: 'UPDATE_TTC_ERROR',
		errors: err
	}
}

export const updateTopTierCustomersSuccess = (data)  => {
	return {
		type: 'UPDATE_TTC_SUCCESS',
		data
	}
}

export function updateTopTierCustomers(id, customers){
	return dispatch => {
		dispatch(updateTopTierCustomersLoading())

		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY }
		const params = {
			id: id,
			customers: customers
		}

		return axios.post(REACT_APP_API_URL + 'top-tier-customers/', params, { headers: AUTH_HEADER })
		.then((response) => {
			// console.log(response);
			// Error explicitly set
			if (!isEmpty(response.data.errors)) {
				dispatch(updateTopTierCustomersError(response.data.errors))

			// Error status
			} else if (!!response.data.status && response.data.status !== 200) {
				dispatch(updateTopTierCustomersError({ 'general': response.data.message }))

			// Success
			} else {
				dispatch(updateTopTierCustomersSuccess(response.data))
			}
		})
		.catch((err) => {
			// console.log('updateTopTierProduct error:', err.response)
			// dispatch(updateTopTierProductError(err.response.data.message))
		})
	}
}


// WEBPACK FOOTER //
// ./src/store/actions/topTier.js